// FETCH ALL GARMENTS_PO_INWARD DETAILS
export const FETCH_GARMENTS_PO_INWARD_DETAILS_REQUEST = 'FETCH_GARMENTS_PO_INWARD_DETAILS_REQUEST';
export const FETCH_GARMENTS_PO_INWARD_DETAILS_SUCCESS = 'FETCH_GARMENTS_PO_INWARD_DETAILS_SUCCESS';
export const FETCH_GARMENTS_PO_INWARD_DETAILS_FAILURE = 'FETCH_GARMENTS_PO_INWARD_DETAILS_FAILURE';

// FETCH ALL GARMENTS_PO_INWARD DETAILS
export const FETCH_GARMENTS_PO_INWARD_DETAILS_WITHOUT_ID_REQUEST = 'FETCH_GARMENTS_PO_INWARD_DETAILS_WITHOUT_ID_REQUEST';
export const FETCH_GARMENTS_PO_INWARD_DETAILS_WITHOUT_ID_SUCCESS = 'FETCH_GARMENTS_PO_INWARD_DETAILS_WITHOUT_ID_SUCCESS';
export const FETCH_GARMENTS_PO_INWARD_DETAILS_WITHOUT_ID_FAILURE = 'FETCH_GARMENTS_PO_INWARD_DETAILS_WITHOUT_ID_FAILURE';

// FETCH ALL PROPERTIES FROM STITCHING_INWARD DETAILS BY ID
export const FETCH_GARMENTS_INWARD_DETAILS_EDIT_QTY_REQUEST = 'FETCH_GARMENTS_INWARD_DETAILS_EDIT_QTY_REQUEST';
export const FETCH_GARMENTS_INWARD_DETAILS_EDIT_QTY_SUCCESS = 'FETCH_GARMENTS_INWARD_DETAILS_EDIT_QTY_SUCCESS';
export const FETCH_GARMENTS_INWARD_DETAILS_EDIT_QTY_FAILURE = 'FETCH_GARMENTS_INWARD_DETAILS_EDIT_QTY_FAILURE';

// CREATE GARMENTS_PO_INWARD DETAILS
export const CREATE_GARMENTS_PO_INWARD_DETAILS_REQUEST = 'CREATE_GARMENTS_PO_INWARD_DETAILS_REQUEST';
export const CREATE_GARMENTS_PO_INWARD_DETAILS_SUCCESS = 'CREATE_GARMENTS_PO_INWARD_DETAILS_SUCCESS';
export const CREATE_GARMENTS_PO_INWARD_DETAILS_FAILURE = 'CREATE_GARMENTS_PO_INWARD_DETAILS_FAILURE';

// UPDATE GARMENTS_PO_INWARD DETAILS
export const UPDATE_GARMENTS_PO_INWARD_DETAILS_REQUEST = 'UPDATE_GARMENTS_PO_INWARD_DETAILS_REQUEST';
export const UPDATE_GARMENTS_PO_INWARD_DETAILS_SUCCESS = 'UPDATE_GARMENTS_PO_INWARD_DETAILS_SUCCESS';
export const UPDATE_GARMENTS_PO_INWARD_DETAILS_FAILURE = 'UPDATE_GARMENTS_PO_INWARD_DETAILS_FAILURE';

// FETCH SINGLE STATE OF GARMENTS_PO_INWARD DETAILS
export const FETCH_SINGLE_GARMENTS_PO_INWARD_DETAILS_REQUEST = 'FETCH_SINGLE_GARMENTS_PO_INWARD_DETAILS_REQUEST';
export const FETCH_SINGLE_GARMENTS_PO_INWARD_DETAILS_SUCCESS = 'FETCH_SINGLE_GARMENTS_PO_INWARD_DETAILS_SUCCESS';
export const FETCH_SINGLE_GARMENTS_PO_INWARD_DETAILS_FAILURE = 'FETCH_SINGLE_GARMENTS_PO_INWARD_DETAILS_FAILURE';

// DELETE GARMENTS_PO_INWARD DETAILS
export const DELETE_GARMENTS_PO_INWARD_DETAILS_REQUEST = 'DELETE_GARMENTS_PO_INWARD_DETAILS_REQUEST';
export const DELETE_GARMENTS_PO_INWARD_DETAILS_SUCCESS = 'DELETE_GARMENTS_PO_INWARD_DETAILS_SUCCESS';
export const DELETE_GARMENTS_PO_INWARD_DETAILS_FAILURE = 'DELETE_GARMENTS_PO_INWARD_DETAILS_FAILURE';

export const RESET_GARMENTS_PO_INWARD_DETAILS_INFO = 'RESET_GARMENTS_PO_INWARD_DETAILS_INFO';

export const CREATE_GARMENTS_PO_INWARD_DETAILS_FORM = 'CREATE_GARMENTS_PO_INWARD_DETAILS_FORM';

export const UPDATE_GARMENTS_PO_INWARD_DETAILS_FORM = 'UPDATE_GARMENTS_PO_INWARD_DETAILS_FORM';

export const RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_GARMENTS_INWARD_ID_V2 = 'RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_GARMENTS_INWARD_ID_V2';
export const SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_GARMENTS_INWARD_ID = 'SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_GARMENTS_INWARD_ID';



export const FETCH_GARMENTS_INWARD_DETAILS_ID_REQUEST = 'FETCH_GARMENTS_INWARD_DETAILS_ID_REQUEST';
export const FETCH_GARMENTS_INWARD_DETAILS_ID_SUCCESS = 'FETCH_GARMENTS_INWARD_DETAILS_ID_SUCCESS';
export const FETCH_GARMENTS_INWARD_DETAILS_ID_FALIURE = 'FETCH_GARMENTS_INWARD_DETAILS_ID_FALIURE';


export const FETCH_GARMENTS_INWARD_DETAILS_PART_COM_REQUEST = 'FETCH_GARMENTS_INWARD_DETAILS_PART_COM_REQUEST';
export const FETCH_GARMENTS_INWARD_DETAILS_PART_COM_SUCCESS = 'FETCH_GARMENTS_INWARD_DETAILS_PART_COM_SUCCESS';
export const FETCH_GARMENTS_INWARD_DETAILS_PART_COM_FALIURE = 'FETCH_GARMENTS_INWARD_DETAILS_PART_COM_FALIURE';


export const FETCH_GARMENTS_INWARD_DETAILS_UNIQUE_ID_REQUEST = 'FETCH_GARMENTS_INWARD_DETAILS_UNIQUE_ID_REQUEST';
export const FETCH_GARMENTS_INWARD_DETAILS_UNIQUE_ID_SUCCESS = 'FETCH_GARMENTS_INWARD_DETAILS_UNIQUE_ID_SUCCESS';
export const FETCH_GARMENTS_INWARD_DETAILS_UNIQUE_ID_FALIURE = 'FETCH_GARMENTS_INWARD_DETAILS_UNIQUE_ID_FALIURE';


export const FETCH_POST_BUNDLE_POST_REQUEST = 'FETCH_POST_BUNDLE_POST_REQUEST';
export const FETCH_POST_BUNDLE_POST_SUCCESS = 'FETCH_POST_BUNDLE_POST_SUCCESS';
export const FETCH_POST_BUNDLE_POST_FALIURE = 'FETCH_POST_BUNDLE_POST_FALIURE';


export const FETCH_BUNDLE_INPUT_REQUEST = 'FETCH_BUNDLE_INPUT_REQUEST';
export const FETCH_BUNDLE_INPUT_SUCCESS = 'FETCH_BUNDLE_INPUT_SUCCESS';
export const FETCH_BUNDLE_INPUT_FALIURE = 'FETCH_BUNDLE_INPUT_FALIURE';


export const FETCH_DETAIL_DC_NO_REQUEST = 'FETCH_DETAIL_DC_NO_REQUEST';
export const FETCH_DETAIL_DC_NO_SUCCESS = 'FETCH_DETAIL_DC_NO_SUCCESS';
export const FETCH_DETAIL_DC_NO_FALIURE = 'FETCH_DETAIL_DC_NO_FALIURE';

export const FETCH_STYLECODE_REQUEST = 'FETCH_STYLECODE_REQUEST';
export const FETCH_STYLECODE_SUCCESS = 'FETCH_STYLECODE_SUCCESS';
export const FETCH_STYLECODE_FAILURE = 'FETCH_STYLECODE_FAILURE';

export const FETCH_STYLECODE_PROGRAM_REQUEST = 'FETCH_STYLECODE_PROGRAM_REQUEST';
export const FETCH_STYLECODE_PROGRAM_SUCCESS = 'FETCH_STYLECODE_PROGRAM_SUCCESS';
export const FETCH_STYLECODE_PROGRAM_FAILURE = 'FETCH_STYLECODE_PROGRAM_FAILURE';